import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useState } from "react";
import {
  createLCWorkedExample as createWorkedExampleService,
  updateLCWorkedExample as updateWorkedExampleService,
  deleteLCWorkedExample as deleteWorkedExampleService,
} from "../../services/learning-continuum/worked-example.service .js";
import {
  createTeachingSuggestion as createTeachingSuggestionService,
  updateTeachingSuggestion as updateTeachingSuggestionService,
  deleteTeachingSuggestion as deleteTeachingSuggestionService,
} from "../../services/learning-continuum/teaching-suggestion.service .js";

import { handlerErrorV2 } from "../../utils/errors.jsx";
import { toggleAlertModule } from "../../store/actions/alert.actions.js";
import useLearningContinuum from "./useLearningContinuum.js";

const useElementsLevels = () => {
  const { curriculumId, id } = useParams();
  const { getLearningContinua } = useLearningContinuum()

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const onUpdateFormData = async () => {
    setIsLoading(true);
    try {
      const response = await getLearningContinua(curriculumId, id);
      if (response.error) {
        setError(response);
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const formData = (form) => {
    return {
      comment: form.comment,
      media: form.media,
    };
  };

  const createWorkedExample = async (levelId, form = {}) => {
    try {
      const data = formData(form);
      const response = await createWorkedExampleService(
        curriculumId,
        id,
        levelId,
        data
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        await onUpdateFormData();
        enqueueSnackbar("Learning continuum updated successfully", {
          variant: "success",
        });
        dispatch(toggleAlertModule());

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    }
  };

  const updateWorkedExample = async (levelId, weId, form = {}) => {
    try {
      const data = formData(form);
      const response = await updateWorkedExampleService(
        curriculumId,
        id,
        levelId,
        weId,
        data
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        await onUpdateFormData();
        enqueueSnackbar("Learning continuum updated successfully", {
          variant: "success",
        });
        dispatch(toggleAlertModule());

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    }
  };

  const deleteWorkedExample = async (levelId, weId) => {
    setIsLoading(true);
    try {
      const response = await deleteWorkedExampleService(
        curriculumId,
        id,
        levelId,
        weId
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        await onUpdateFormData();
        enqueueSnackbar("Learning continuum updated successfully", {
          variant: "success",
        });

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    } finally {
      setIsLoading(false);
    }
  };

  const createTeachingSuggestion = async (levelId, form = {}) => {
    try {
      const data = formData(form);
      const response = await createTeachingSuggestionService(
        curriculumId,
        id,
        levelId,
        data
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        await onUpdateFormData();
        enqueueSnackbar("Learning continuum updated successfully", {
          variant: "success",
        });
        dispatch(toggleAlertModule());

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    }
  };

  const updateTeachingSuggestion = async (levelId, weId, form = {}) => {
    try {
      const data = formData(form);
      const response = await updateTeachingSuggestionService(
        curriculumId,
        id,
        levelId,
        weId,
        data
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        await onUpdateFormData();
        enqueueSnackbar("Learning continuum updated successfully", {
          variant: "success",
        });
        dispatch(toggleAlertModule());

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    }
  };

  const deleteTeachingSuggestion = async (levelId, weId) => {
    setIsLoading(true);
    try {
      const response = await deleteTeachingSuggestionService(
        curriculumId,
        id,
        levelId,
        weId
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        await onUpdateFormData();
        enqueueSnackbar("Learning continuum updated successfully", {
          variant: "success",
        });

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    createWorkedExample,
    updateWorkedExample,
    deleteWorkedExample,

    createTeachingSuggestion,
    updateTeachingSuggestion,
    deleteTeachingSuggestion,
  };
};

export default useElementsLevels;
